import { router } from './router'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import { i18n } from '@/i18n'

export async function permsInit() {
  router.beforeEach(async(to, from, next) => {
    NProgress.start()
    console.log(`from ${from.path} to ${to.path}`)
    next()
  })

  router.afterEach((to, from) => {
    document.title = (to.meta.title ? `${to.meta.title} - ` : '') + `${i18n.t('header.title')}`
    NProgress.done() // 结束Progress
  })
}
